import { Tabs } from '@mantine/core';
import classes from './Tabs.module.css';

export const TabsConfig = Tabs.extend({
  classNames: {
    list: classes.list,
    tab: classes.tab,
  },
});
